import { z } from "zod";

export const getCustomerEditFormSchema = () => {
	return z.object({
		name: z.string().nullish(),
		phone: z.string().nullish(),
		email: z.string().email().nullish(),
		invoicingName: z.string().nullish(),
		invoicingAddress: z.string().nullish(),
		businessId: z.string().nullish(),
	});
};

export type CustomerEditFormModel = z.infer<
	ReturnType<typeof getCustomerEditFormSchema>
>;
